@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ClickableText {
  @extend %font-family-primary;

  cursor: pointer;

  p {
    color: $theme-color-links;
    font-weight: $font-weight-semibold;
  }

  p:hover {
    text-decoration: underline !important;
  }
}
